import React from "react";

import { PALETTE } from "../../common/ThemeConstants";
import { Row, Col } from "react-bootstrap";
import { FaCheck, FaLock } from "react-icons/fa";

export default function SubscriptionFeatureList({
  features,
  color,
  roundedClassName = "rounded-md",
}) {
  console.log(features)
  return (
    <div
      className={roundedClassName}
      style={{ maxWidth: 420, padding: 8, background: PALETTE.LIGHTGRAY }}
    >
      <div
        className={roundedClassName + " py-1 shadow"}
        style={{ background: color, width: "100%" }}
      >
        {features.map((feature, idx) => (
          <Row key={idx} className="my-3 m-auto" style={{ width: "100%" }}>
            <Col xs={2} className="text-center align-self-center px-0">
              {feature.premium ? (
                <>
                  <FaCheck size={25} color={PALETTE.MAINCOLORHOVER} />
                  <FaCheck
                    size={25}
                    color={PALETTE.SECONDARYCOLORTRANSPARENT}
                    style={{ marginLeft: -25 }}
                  />
                </>
              ) : (
                <FaLock size={25} color={PALETTE.KINDAGRAY} />
              )}
            </Col>
            <Col xs={10} className="text-start  align-self-center px-0">
              <p className="mb-0">{feature.name}</p>
              <p className="mb-0" style={{ fontSize: 14, color: PALETTE.GRAY }}>
                {feature.description}
              </p>
            </Col>
          </Row>
        ))}
      </div>
    </div>
  );
}
